class PasswordEye extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="password"]');
    this.eyeButton = this.querySelector('.eye');
    this.eyeButton.addEventListener('click', (ev) => {
      this.toggleVisibilityState();
    });
  }

  toggleVisibilityState() {
    this.input.type = this.input.type === 'text' ? 'password' : 'text';
    this.eyeButton.querySelectorAll('use').forEach((use) => {
      use.classList.toggle('hidden');
    });
  }
}

customElements.define('password-eye', PasswordEye);
